module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/discount.svg?fb8b559b";